/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
*/

import { type FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

// Compatibility for old bookmarks: session setup no longer asks for a password.
export const StaffJoinSetup: FC = () => {
  const { state } = useLocation();
  const from = state?.from;
  const path = from?.pathname;
  return (
    <Navigate
      to={
        typeof path === "string" &&
        path.startsWith("/") &&
        !path.startsWith("//") &&
        path !== "/connect"
          ? from
          : "/"
      }
      replace
    />
  );
};
